import { MCP_TOOL_COUNT, MCP_TOOL_GROUPS } from '~/lib/mcp-catalog';

/** Native disclosure keeps the directory usable without client-side search. */
export function McpGuideNavigation() {
  return (
    <div className="mcp-guide-navigation">
      <nav
        aria-label="MCP guide shortcuts"
        className="mcp-guide-shortcuts"
      >
        <a href="#connect-your-assistant">1. Connect your assistant</a>
        <a href="#practical-workflows">2. Choose a workflow</a>
        <a href="#account-and-sender-tools">3. Tool reference</a>
      </nav>
      <details className="mcp-tool-index">
        <summary>
          Jump to a tool <span>{MCP_TOOL_COUNT} tools</span>
        </summary>
        <nav
          aria-label="MCP tool directory"
          className="mcp-tool-index-groups"
        >
          {MCP_TOOL_GROUPS.map((group) => (
            <div key={group.id}>
              <p>{group.title}</p>
              <ul>
                {group.tools.map((tool) => (
                  <li key={tool.name}>
                    <a href={`#${tool.name}`}>{tool.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </details>
    </div>
  );
}
